import { CartAddEvent } from '@theme/events';

const ADDED_MS = 3000;

function sectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
  });
  return [...ids];
}

function showAddedLine() {
  document.querySelectorAll('.vela-drawer__added').forEach((el) => {
    el.hidden = false;
    el.removeAttribute('hidden');
    window.clearTimeout(el._velaAddedTimer);
    el._velaAddedTimer = window.setTimeout(() => {
      el.setAttribute('hidden', '');
    }, ADDED_MS);
  });
}

function syncEmptyOnly(count) {
  const hide = typeof count === 'number' && count > 0;
  document.querySelectorAll('.vela-empty-cart-only').forEach((el) => {
    const sec = el.closest('.shopify-section') || el;
    sec.style.display = hide ? 'none' : '';
  });
}

function cartHrefIsForbidden(href) {
  if (!href) return false;
  try {
    const url = new URL(href, window.location.origin);
    const path = url.pathname.replace(/\/+$/, '') || '/';
    return path === '/cart' || path === '/cart/add' || path.startsWith('/cart/add');
  } catch (err) {
    const path = String(href).split('?')[0].replace(/\/+$/, '');
    return path === '/cart' || path === '/cart/add' || path.endsWith('/cart') || path.endsWith('/cart/add');
  }
}

function openExistingDrawer() {
  const drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
    return;
  }
  if (drawer && typeof drawer.showDialog === 'function') {
    drawer.showDialog();
    return;
  }
  const dialog = drawer?.querySelector?.('dialog');
  if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
    dialog.showModal();
    return;
  }
}

document.addEventListener(CartAddEvent.eventName, (event) => {
  const count = event.detail?.data?.itemCount ?? event.detail?.resource?.item_count;
  showAddedLine();
  if (typeof count === 'number') syncEmptyOnly(count);
});

document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-vela-addon-add]');
  if (!btn) return;
  event.preventDefault();
  const id = Number(btn.getAttribute('data-variant-id'));
  if (!id) return;
  btn.disabled = true;
  try {
    const body = {
      items: [{ id, quantity: 1 }],
      sections: sectionIds().join(','),
      sections_url: window.location.pathname,
    };
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('add failed');
    const data = await res.json();
    document.dispatchEvent(
      new CartAddEvent(data, 'vela-addon', {
        source: 'vela-addon',
        itemCount: data.item_count,
        variantId: String(id),
        sections: data.sections,
      })
    );
  } catch (err) {
    console.error('vela-addon', err);
  } finally {
    btn.disabled = false;
  }
});

document.addEventListener('input', (event) => {
  const ta = event.target.closest('.vela-gift textarea');
  if (!ta) return;
  if (ta.value.length > 80) ta.value = ta.value.slice(0, 80);
});

if (location.hash === '#vela-open-cart') {
  const open = () => openExistingDrawer();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(open, 400));
  } else {
    setTimeout(open, 400);
  }
}
